import { Component, OnInit, Output, EventEmitter } from '@angular/core';

import { environment } from 'src/environments/environment';
import { NavLink } from 'src/app/shared/models/interfaces/nav-link.model';
import { UiService } from 'src/app/shared/services/ui.service';
import { AuthUser } from 'src/app/shared/models/classes/auth/auth-user';
import { Subscription } from 'rxjs';


@Component({
    selector: 'app-main-nav',
    templateUrl: './main-nav.component.html',
    styleUrls: ['./main-nav.component.scss']
})
export class MainNavComponent implements OnInit {
    @Output() sidenavClose = new EventEmitter<void>();

    infoLinks: NavLink[];
    user: AuthUser;

    isAuth: boolean;
    appVersion: string;

    constructor(
        private uiSrv: UiService
    ) { }

    ngOnInit() {
        this.appVersion = environment.version;
        this.setLinks();
    }

    onCloseSidenav(): void {
        this.sidenavClose.emit();
    }

    private setLinks(): void {
        this.infoLinks = this.uiSrv.getInfoLinks();
    }
}
